import { Shield, Stethoscope, Heart, Building2 } from "lucide-react";
import { useRole } from "../../../contexts/RoleContext";
import type { UserRole } from "../../../shared/schema";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../components/ui/select";

const roles: { value: UserRole; label: string; labelVi: string; icon: typeof Shield }[] = [
  { value: "admin", label: "Administrator", labelVi: "Quản trị viên", icon: Shield },
  { value: "doctor", label: "Doctor", labelVi: "Bác sĩ", icon: Stethoscope },
  { value: "nurse", label: "Nurse", labelVi: "Điều dưỡng", icon: Heart },
  { value: "department_head", label: "Department Head", labelVi: "Trưởng khoa", icon: Building2 },
];

export function RoleSelector() {
  const { role, setRole } = useRole();
  const currentRole = roles.find(r => r.value === role);

  return (
    <Select value={role} onValueChange={(value) => setRole(value as UserRole)}>
      <SelectTrigger 
        className="w-[200px] gap-2" 
        data-testid="select-role"
      >
        {currentRole && <currentRole.icon className="h-4 w-4 text-muted-foreground" />}
        <SelectValue placeholder="Chọn vai trò" />
      </SelectTrigger>
      <SelectContent>
        {roles.map((r) => (
          <SelectItem 
            key={r.value} 
            value={r.value}
            data-testid={`select-role-${r.value}`}
          >
            <div className="flex items-center gap-2">
              <r.icon className="h-4 w-4 text-muted-foreground" />
              <span>{r.labelVi}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
